import React from 'react';
import Modal from '../ui/Modal';
import FeedbackForm from './FeedbackForm';
import Button from '../ui/Button';

type Props = React.ComponentProps<typeof FeedbackForm> & {
  isOpen: boolean;
  onClose: () => void;
};

export default function FeedbackDialog({ isOpen, onClose, ...form }: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Give feedback" size="lg" className="vein-product-dialog"
      footer={
        <div className="flex justify-end">
          <Button variant="ghost" onClick={onClose}>
            {form.submitting ? 'Close' : (form.draft.message || form.draft.category !== 'comment') && !form.receipt ? 'Close and keep draft' : 'Done'}
          </Button>
        </div>
      }>
      <div className="space-y-4">
        {!form.receipt && <p className="text-sm text-gray-600">Questions, ideas, or something not working? Leave a message for our team anytime.</p>}
        <FeedbackForm {...form} />
      </div>
    </Modal>
  );
}
